import React, { useContext, useEffect, useState } from "react";
import "./Manage_address.css";
import Heading_banner_section from "../../common_components/heading_banner/Heading_banner_section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import Address_cards from "../../common_components/address_cards/Address_cards";
import Purple_border_btn from "../../common_components/common_btn/purple_border_btn/Purple_border_btn";
import { useNavigate } from "react-router-dom";
import { getAddress } from "../../../utils/luxuryapis/orderProcess/orderProcess";
import { Context } from "../../../utils/context";
import LogoutModal from "../../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";
function Manage_address() {
  const navigate = useNavigate();
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "YOUR ACCOUNT", link: "/luxury/account" },
    { label: "Manage Address" },
  ];
  const { userdata, setSignin } = useContext(Context);
  const [address, setAddress] = useState();

  const getAllData = async () => {
    const res = await getAddress();
    if (res?.success) {
      setAddress(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);
  const [logoutshow, setLogoutshow] = useState(false);
  return (
    <>
      <section className="All_Orders Communication_preferences Manage_address">
        <Heading_banner_section
          headingText={`${userdata?.first_name} ${userdata?.last_name}`}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="all_order_section_holder">
                <div className="text_holder">
                  <h3
                    className="sign_out_text"
                    onClick={() => setLogoutshow(true)}
                  >
                    <FontAwesomeIcon
                      className="me-3"
                      icon={faArrowRightFromBracket}
                    />
                    SIGN OUT
                  </h3>
                </div>

                <div className="heading_tab_content_holder">
                  <div className="heading_holder">
                    <h1>MANAGE ADDRESS</h1>
                    {/* <p>
                      <Form.Check
                        type="checkbox"
                        label="is shipping address same as billing address"
                      />
                    </p> */}
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="address_cards_holder">
                      <div className="row justify-content-center">
                        {address?.map((val) => (
                          <div className="col-md-4">
                            <Address_cards
                              value={val}
                              radio_status={true}
                              getAllData={getAllData}
                            />
                          </div>
                        ))}

                        {/* <div className="col-md-4">
                          <Address_cards />
                        </div> */}
                      </div>
                    </div>

                    <div className="btn_holder">
                      <Purple_Btn
                        btnText="Add New Address"
                        onClick={() => navigate("/luxury/add-address")}
                      />

                      {/* <div>
                        <Purple_border_btn btnText="Delete Address" />
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>
    </>
  );
}

export default Manage_address;
